import { useQuery } from '@tanstack/react-query';
import { CustomFieldDefinitionWithTargets } from 'types/customField';
import request from 'utils/request';

export const SEQUENCES_CUSTOM_FIELDS_KEY = 'sequences-custom-fields';

function getSequenceCustomFields() {
  return request('/sequences-custom-fields', {
    method: 'GET',
  }).then<CustomFieldDefinitionWithTargets[]>(res => res.data);
}

export const useSequenceCustomFieldDefinitions = () =>
  useQuery({
    queryKey: [SEQUENCES_CUSTOM_FIELDS_KEY],
    queryFn: getSequenceCustomFields,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
